function getDateString(date, locales = "de-DE", options) {
  return date.toLocaleDateString(locales, options);
}

// helper to generate a valid datetime string for time html-element
function getDatetimeString(date) {
  return date.toISOString().slice(0, 10);
}

export { getDateString, getDatetimeString };
